import { useDrawer } from "../../../components/ui/Drawer/useDrawer";
import { CustomerDetailsModel } from "../../models/customerDetails";
import { useCustomerDetails } from "../../../store/customer/useCustomerDetails";

export const CUSTOMER_DETAILS_DRAWER_NAME = "customer-details-drawer";

export default class CustomerDetailsController {
  constructor({ model, drawerActions } = {}) {
    this.model = model || CustomerDetailsModel();
    this.drawerActions = drawerActions || useDrawer.getState().actions;
    this.requestVersions = {};
  }

  open = (customerId) => {
    if (!customerId) return false;

    const normalizedCustomerId = String(customerId);
    useCustomerDetails.getState().actions.selectCustomer(normalizedCustomerId);
    this.drawerActions.isOpen(CUSTOMER_DETAILS_DRAWER_NAME, true);

    return this.load(normalizedCustomerId);
  };

  load = async (customerId) => {
    const actions = useCustomerDetails.getState().actions;
    const requestVersion = (this.requestVersions[customerId] || 0) + 1;
    this.requestVersions[customerId] = requestVersion;
    actions.setRequestState(customerId);

    const result = await this.model.find(customerId);

    if (this.requestVersions[customerId] !== requestVersion) return false;

    if (!result?.details) {
      actions.setError(
        customerId,
        result?.error || "Não foi possível carregar os detalhes do cliente."
      );
      return false;
    }

    actions.setDetails(customerId, result.details);
    return result.details;
  };

  retry = () => {
    const customerId = useCustomerDetails.getState().data.activeCustomerId;
    if (!customerId) return false;
    return this.load(customerId);
  };

  close = () => {
    useCustomerDetails.getState().actions.close();
    this.drawerActions.isOpen(CUSTOMER_DETAILS_DRAWER_NAME, false);
  };
}
